export default __webpack_public_path__ + "static/media/Custom-Sheet-Metal-Fabrication-Surgent-Construction.661a7c07.jpg";